import { DASHBOARD_TASKS, DASHBOARD_TILES, defineModule } from "@motolynk/app-core";

import { LowStockTile, ProductsTile, ProductTasks } from "./admin/dashboard";
import { VendorProductsTile, VendorProductTasks, VendorStockTile } from "./vendor/dashboard";

import en from "./i18n/en.json";

export const productsModule = defineModule({
  name: "products",
  label: "Products",
  requires: [
    "core",
    "geo",
    "accounts",
    "configuration",
    "audit",
    "medialib",
    "notifications",
    "vehicles",
    "taxes",
    "catalog",
    "vendors",
  ],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "products",
        permission: "products.view_product",
        page: () => import("./admin/ProductsPage"),
      },
      {
        path: "products/new",
        permission: "products.add_product",
        page: () => import("./admin/NewProductPage"),
      },
      {
        path: "products/compatibility",
        permission: "products.view_product",
        page: () => import("./admin/CompatibilityPage"),
      },
      {
        path: "products/:uid",
        permission: "products.view_product",
        page: () => import("./admin/ProductPage"),
      },
    ],
    nav: [
      {
        id: "products",
        group: "catalog",
        label: "products:nav.products",
        icon: "package",
        to: "/products",
        permission: "products.view_product",
        order: 1,
      },
      {
        id: "compatibility",
        group: "catalog",
        label: "products:nav.compatibility",
        icon: "car",
        to: "/products/compatibility",
        permission: "products.view_product",
        order: 6,
      },
    ],
    slots: {
      [DASHBOARD_TILES]: [
        { id: "products", permission: "products.view_product", order: 40, component: ProductsTile },
        {
          id: "low-stock",
          permission: "products.view_product",
          order: 50,
          component: LowStockTile,
        },
      ],
      [DASHBOARD_TASKS]: [
        { id: "products", permission: "products.view_product", order: 20, component: ProductTasks },
      ],
    },
  },
  // the store's own products (team-role code `products.manage`, ADR 0029)
  vendor: {
    routes: [
      {
        path: "products",
        permission: "products.manage",
        page: () => import("./vendor/ProductsPage"),
      },
      {
        path: "products/new",
        permission: "products.manage",
        page: () => import("./vendor/NewProductPage"),
      },
      {
        path: "products/:uid",
        permission: "products.manage",
        page: () => import("./vendor/ProductPage"),
      },
      { path: "stock", permission: "inventory.manage", page: () => import("./vendor/StockPage") },
    ],
    slots: {
      [DASHBOARD_TILES]: [
        { id: "products", permission: "products.manage", order: 20, component: VendorProductsTile },
        { id: "stock", permission: "inventory.manage", order: 30, component: VendorStockTile },
      ],
      [DASHBOARD_TASKS]: [{ id: "products", order: 10, component: VendorProductTasks }],
    },
    nav: [
      {
        id: "products",
        group: "catalog",
        label: "products:nav.products",
        icon: "package",
        to: "/products",
        permission: "products.manage",
        order: 10,
      },
      {
        id: "stock",
        group: "catalog",
        label: "products:nav.stock",
        icon: "box",
        to: "/stock",
        permission: "inventory.manage",
        order: 15,
      },
    ],
  },
});
